import { render, staticRenderFns } from "./OrdersGrid.vue?vue&type=template&id=52f6e3a0&scoped=true&"
import script from "./OrdersGrid.vue?vue&type=script&lang=js&"
export * from "./OrdersGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrdersGrid.vue?vue&type=style&index=0&id=52f6e3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6e3a0",
  null
  
)

export default component.exports